export const tasksMock = [
    {
        titulo: "Tarea 1",
        type_task: "Tarea",
        asignado: "Juan Perez",
        fecha_plan: "2021-10-10",
        fecha_culm: "2021-10-10",
        estado: "20%",
    },
    {
        titulo: "Tarea 1",
        type_task: "Tarea",
        asignado: "Juan Perez",
        fecha_plan: "2021-10-10",
        fecha_culm: "2021-10-10",
        estado: "20%",
    },
    {
        titulo: "Tarea 1",
        type_task: "Tarea",
        fecha_plan: "2021-10-10",
        fecha_culm: "2021-10-10",
        estado: "20%",
    },
    {
        titulo: "Tarea 1",
        type_task: "Tarea",
        asignado: "Juan Perez",
        fecha_plan: "2021-10-10",
        fecha_culm: "2021-10-10",
        estado: "20%",
    },
    {
        titulo: "Tarea 1",
        type_task: "Tarea",
        asignado: "Juan Perez",
        fecha_plan: "2021-10-10",
        fecha_culm: "2021-10-10",
        estado: "20%",
    },
    {
        titulo: "Tarea 1",
        type_task: "Tarea",
        asignado: "Juan Perez",
        fecha_plan: "2021-10-10",
        fecha_culm: "2021-10-10",
        estado: "20%",
    },
];

export const typeTaskMock = [
    {
        title: "Pendientes",
        status:"pending",
        bgColor: "#F2F2F2",
        chipColor: "#dfdfdf",
        textColor: "#000",
        iconColor: "#000",
    },
    {
        title: "En Proceso",
        status:"inProgress",
        bgColor: "#F3F8FD",
        chipColor: "#0F75E2",
        textColor: "#fff",
        iconColor: "#fff",
    },
    {
        title: "Por Validar",
        status:"analyzing",
        bgColor: "#FFF5E4",
        chipColor: "#FFBE46",
        textColor: "#fff",
        iconColor: "#fff",
    },
    {
        title: "Completada",
        status:"completed",
        bgColor: "#F4F9F7",
        chipColor: "#278C5C",
        textColor: "#fff",
        iconColor: "#fff",
    },
    {
        title: "Descartada",
        status:"discarded",
        bgColor: "#F2F2F2",
        chipColor: "#dfdfdf",
        textColor: "#000",
        iconColor: "#000",
    },
    {
        title: "Bloqueadas",
        status:"blocked",
        bgColor: "#D9D1CD",
        chipColor: "#706D6D",
        textColor: "#fff",
        iconColor: "#fff",
    },
];
